<div class="group-invite-container ya-typography" (swiperight)="SwiperNavigateBack()">
  <div class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
    <div class="ya-invitation-content">
      <div class="invitation-content_header">
        <div class="group-icon">
          <div class="inline-icon" inlineSVG="hypersoft-user-multi.svg"></div>
        </div>
        <div class="content-container">
          <h2 class="title" [innerHTML]="welcomeLabel"></h2>
          <span class="text content-container--subfont" langkey="phRemoteOrder_Entry_SubText"></span>
        </div>
      </div>
      <div class="name-inupt-form">
        <div class="ya-input-container">
          <div class="ya-input-wrapper">
            <div class="inputs-text">
              <input type="text" class="ya-input-text" (blur)="setWebView()" [placeholder]="inputPlaceholder"
                [formControl]="usernameInputControl">
            </div>
            <ng-container *ngIf="usernameInputControl.touched && usernameInputControl.invalid">
              <ng-container *ngIf="usernameInputControl.errors && activeError(usernameInputControl, field.UserName)">
                <ya-errorvalidation [controlValidation]="true" [errorMessage]="activeError(usernameInputControl, field.UserName)"></ya-errorvalidation>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="ya-button-group-wrapper">
        <div class="ya-button-group-container">
          <ng-container *ngIf="setBtnStateByUserName(); then activeButton else disableButton">
          </ng-container>
          <ng-template #activeButton>
            <div class="ya-webshop-button-container">
              <button mat-flat-button (click)="joinGroupOrder()">
                <span langkey="phRemoteOrder_Entry_Join_Btn"></span>
              </button>
            </div>
          </ng-template>
          <ng-template #disableButton>
            <div class="ya-webshop-button-container">
              <button mat-flat-button disabled>
                <span langkey="phGroupOrder_Invitation_Recieved_Join_Btn"></span>
              </button>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="ya-webshop-button-container webshop-ghost-button">
      <button mat-flat-button (click)="denyGroupOrder()">
        <span langkey="phRemoteOrder_Entry_Deny_Btn"></span>
      </button>
    </div>
  </div>
</div>